export class DomainResponse {
    limit: number;
    offset: number;
    resultCount: number;
    results?: (DomainResultsEntity)[] | null;
    sortBy: string;
}

class DomainResultsEntity {
    ldapSourceId: number;
    ldapSourceName: string;
}
